export const getCookie = (key: string): string | null => {
  const target = `${key}=`;
  const cookies = decodeURIComponent(document.cookie).split(";");

  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(target)) {
      return cookie.slice(target.length);
    }
  }

  return null;
};

const getRootDomain = () => {
  const parts = window.location.hostname.split(".");
  return parts.length > 1 ? `.${parts.slice(-2).join(".")}` : window.location.hostname;
};

export const setCookie = (key: string, value: string, expInDays = 7, path = "/"): string => {
  const expires = new Date(Date.now() + expInDays * 864e5).toUTCString();
  const domain = getRootDomain();
  const secure = window.location.protocol === "https:" ? ";Secure" : "";
  document.cookie = `${key}=${value};expires=${expires};path=${path};domain=${domain};SameSite=Lax${secure}`;
  return value;
};
